module.exports = __webpack_public_path__ + "static/media/nodejs.d8b3d691.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/nodejs.png
// module id = 164
// module chunks = 0